import { useEffect, useState } from "react";
import { DetailPanelUserRow } from "./DetailPanelUserRow";
import { Project, User } from "interfaces";
import { useSnackbar } from "providers/SnackbarProvider";
import {
  getDetailProject,
  removeUserFromProject,
  shareProject,
} from "services";
import { useConfirmDialogExit } from "hooks";
import {
  buttonRemove,
  modalRemoveUserTitle,
  modalShareProjectSubtitle,
  panelLabelUsers,
  snackbarEmailSentToSpecifiedEmail,
  snackbarSummarySuccessSendEmail,
  snackbarUserRemovedFromProjectSubTitlePart1,
  snackbarUserRemovedFromProjectSubTitlePart2,
  snackbarUserRemovedFromProjectTitle,
} from "_constants";
import { PrimeIcons } from "primereact/api";
import { useAppDispatch, useAppSelector } from "store/store";
import {
  setCurrentProject,
  setLoadingPanelProjects,
  UpdateProject,
} from "store/slicer/GestioneProjectsSlice";
import { DetailPanelEmptyUsersList } from "./DetailPanelEmptyUsersList";
import { getUserId } from "utils";

export const DetailPanelUserslist = ({
  usersList,
  project,
  projectId,
}: {
  usersList: User[];
  project: Project;
  projectId?: string;
}) => {
  const [users, setUsers] = useState(usersList);
  const [firstLoad, setFirstLoad] = useState(true);
  const dispatch = useAppDispatch();
  const { showSnackbar } = useSnackbar();
  const { showConfirmDialogDelete } = useConfirmDialogExit();
  const currentProject = useAppSelector(
    (state) => state.gestioneProjectsSlice.currentProject
  );
  const loadedDetailProject = useAppSelector(
    (state) => state.gestioneProjectsSlice.loadedPanel
  );

  useEffect(() => {
    setUsers(usersList);
  }, [usersList]);

  useEffect(() => {
    if (project?.id && !loadedDetailProject && !firstLoad) {
      getDetailProject(project.id)
        .then((response) => {
          dispatch(setCurrentProject(response.data as any));
          setUsers(response.data.users!);
        })
        .catch((_) => {})
        .finally(() => {
          dispatch(setLoadingPanelProjects(true));
        });
    }
    if (!loadedDetailProject && firstLoad) {
      dispatch(setLoadingPanelProjects(true));
    }
    setFirstLoad(false);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, loadedDetailProject, project.id]);
  const showModalRemoveUserFromList = (user: User) => {
    if (user.id) {
      showConfirmDialogDelete({
        title: modalRemoveUserTitle,
        subtitle: `${modalShareProjectSubtitle}<b class="capitalize">${user.name} ${user.lastName}?</b>`,
        rejectButtonLabel: buttonRemove,
        rejectCallback: () => removeUserFromList(user),
        icon: PrimeIcons.USER_MINUS,
      });
    }
  };
  const reSendInviteProjectUser = (user: User) => {
    if (user.id && (project.id ?? projectId)) {
      shareProject({
        projectId: projectId ? projectId : project.id ?? "",
        userIdsList: [user?.userId ?? ""],
      })
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarSummarySuccessSendEmail,
            detail: snackbarEmailSentToSpecifiedEmail,
            life: 5000,
          });
        })
        .catch((_) => {});
    }
  };
  const removeUserFromList = (user: User) => {
    if (user.id && (project.id ?? projectId)) {
      removeUserFromProject({
        projectId: projectId ? projectId : project.id ?? "",
        userId: user.id,
      })
        .then((_) => {
          showSnackbar({
            severity: "success",
            summary: snackbarUserRemovedFromProjectTitle,
            detail: `${snackbarUserRemovedFromProjectSubTitlePart1}"${
              user.name
            }" ${snackbarUserRemovedFromProjectSubTitlePart2} "${
              project.name ?? ""
            }"`,
            life: 5000,
          });

          const filteredList = users.filter(
            (item: User) => item.id !== user.id
          );
          const tempCurrentProject = JSON.parse(JSON.stringify(currentProject));
          tempCurrentProject.users = filteredList;
          if (!filteredList?.length) {
            tempCurrentProject.type = "PRIVATE";
          }
          setUsers(filteredList);
          dispatch(UpdateProject(tempCurrentProject));
        })
        .catch((_) => {});
    }
  };

  useEffect(() => {}, [currentProject]);

  return (
    <div className="flex-container padd-18 column detail-panel-users-container">
      <span className="text-base-bold text margin-bottom-22">
        {panelLabelUsers}
      </span>
      {users?.length ? (
        users?.map((user: User) => (
          <DetailPanelUserRow
            user={user}
            key={user.id}
            deleteCallback={showModalRemoveUserFromList}
            shareCallback={reSendInviteProjectUser}
            showAction={currentProject?.createdById === getUserId()}
          />
        ))
      ) : (
        <DetailPanelEmptyUsersList />
      )}
    </div>
  );
};
